import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { HomeComponent } from './public-pages/home/home.component';

import { AuthNotGuard } from './_guards/auth-not.guard';
import { AuthGuard } from './_guards/auth.guard';
import { RoleGuard } from './_guards/user_role.guard';
import { ProfileResolver } from './_resolvers/profile.resolver';

import { LoginComponent } from './auth-pages/login/login.component';
import { RegisterComponent } from './auth-pages/register/register.component';
import { VerifyEmailComponent } from './auth-pages/verify-email/verify-email.component';
import { ResendVerificationComponent } from './auth-pages/resend-verification/resend-verification.component';
import { ForgotPasswordComponent } from './auth-pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth-pages/reset-password/reset-password.component';

import { AdminLayoutComponent } from './admin-pages/admin-layout/admin-layout.component';
import { AdminDashboardComponent } from './admin-pages/admin-dashboard/admin-dashboard.component';
import { AdminBlogsComponent } from './admin-pages/admin-blogs/admin-blogs.component';
import { AdminBlogFormComponent } from './admin-pages/admin-blogs/admin-blog-form/admin-blog-form.component';
import { AdminMembersList } from './admin-pages/admin-members/admin-members-list/admin-members-list';
import { AdminMemberDetails } from './admin-pages/admin-members/admin-member-details/admin-member-details';
import { PublicBlogDetails } from './public-pages/blogs/public-blog-details/public-blog-details';
import { PublicBlogsList } from './public-pages/blogs/public-blogs-list/public-blogs-list';
import { ProtectionServiceComponent } from './public-pages/services/protection-service/protection-service.component';
import { ControleServiceComponent } from './public-pages/services/controle-service/controle-service.component';
import { EventsSecurityServiceComponent } from './public-pages/services/events-security-service/events-security-service.component';

import { GardiennageChantierService } from './public-pages/services/gardiennage-chantier-service/gardiennage-chantier-service';
import { GardiennageIndustrielService } from './public-pages/services/gardiennage-industriel-service/gardiennage-industriel-service';
import { AccueilEtGestionService } from './public-pages/services/accueil-et-gestion-service/accueil-et-gestion-service';
import { PublicReservationComponent } from './public-pages/public-reservation/public-reservation.component';

import { AdminReservationsListComponent } from './admin-pages/admin-reservation/admin-reservations-list/admin-reservations-list.component';
import { AdminReservationDetailsComponent } from './admin-pages/admin-reservation/admin-reservation-details/admin-reservation-details.component';
import { AdminOfferFormComponent } from './admin-pages/admin-reservation/admin-offer-form/admin-offer-form.component';
import { AdminAgentsList } from './admin-pages/admin-agents/admin-agents-list/admin-agents-list';
import { AdminAgentDetails } from './admin-pages/admin-agents/admin-agent-details/admin-agent-details';
import { AdminAgentForm } from './admin-pages/admin-agents/admin-agent-form/admin-agent-form';
import { AdminMemberForm } from './admin-pages/admin-members/admin-member-form/admin-member-form';
import { MemberLayoutComponent } from './member-pages/member-layout/member-layout.component';
import { MemberProfile } from './member-pages/member-profile/member-profile';
import { MemberReservations } from './member-pages/member-reservations/member-reservations';
import { MemberReservationDetails } from './member-pages/member-reservations/member-reservation-details/member-reservation-details';
import { MemberReservationUpdate } from './member-pages/member-reservations/member-reservation-update/member-reservation-update';
import { FeedbackFormComponent } from './member-pages/feedback-form/feedback-form.component';
import { FeedbackListComponent } from './member-pages/feedback-list/feedback-list.component';
import { FeedbackDetailsComponent } from './member-pages/feedback-details/feedback-details.component';
import { MemberReservationCreate } from './member-pages/member-reservations/member-reservation-create/member-reservation-create';
import { PublicContactComponent } from './public-pages/public-contact/public-contact.component';
import { AdminContactsList } from './admin-pages/admin-contacts/admin-contacts-list/admin-contacts-list';
import { AdminContactDetails } from './admin-pages/admin-contacts/admin-contact-details/admin-contact-details';
import { AdminPeriodManagement } from './admin-pages/admin-period-management/admin-period-management';


export const routes: Routes = [
    { path: '', component: HomeComponent,  data: { title: 'Accueil'} },
    { path: 'home', component: HomeComponent,  data: { title: 'Accueil'} },
    { path: 'contact', component: PublicContactComponent,  data: { title: 'Contactez-nous'} },
    { path: 'articles/:slug', component: PublicBlogDetails, data: { title: 'Articles'} },
    { path: 'articles', component: PublicBlogsList,  data: { title: 'Articles'} },

    { path: 'services/protection-de-bien-mobilier-et-immobilier', component: ProtectionServiceComponent,  data: { title: 'Protection de bien mobilier et immobilier'} },
    { path: 'services/controle-des-personnes-et-dacces', component: ControleServiceComponent,  data: { title: "Contrôle des personnes et d'accès"} },
    { path: 'services/securite-evenementielle', component: EventsSecurityServiceComponent,  data: { title: "Sécurité événementielle"} },
    { path: 'services/gardiennage-chantier', component: GardiennageChantierService,  data: { title: "Gardiennage chantier"} },
    { path: 'services/gardiennage-industriel', component: GardiennageIndustrielService,  data: { title: "Gardiennage industriel"} },
    { path: 'services/accueil-et-gestion', component: AccueilEtGestionService,  data: { title: "Accueil et gestion"} },

    { path: 'reservation', component: PublicReservationComponent,  data: { title: "Réservation"} },


    { path: 'login', component: LoginComponent, data: {title: 'Se Connecter'}, canActivate: [AuthNotGuard]},
    { path: 'register', component: RegisterComponent, data: {title: 'Inscription'}, canActivate: [AuthNotGuard]},
    { path: 'verify-email', component: VerifyEmailComponent, data: {title: 'Inscription'}, canActivate: [AuthNotGuard] },
    { path: 'resend-verification', component: ResendVerificationComponent, data: {title: 'Se Connecter'}, canActivate: [AuthNotGuard] },

    { path: 'forgot-password', component: ForgotPasswordComponent, data: {title: "Mot de passe oublié"}, canActivate: [AuthNotGuard] },
    { path: 'reset-password', component: ResetPasswordComponent, data: {title: "Réinitialiser le mot de passe"}, canActivate: [AuthNotGuard] },


     {
      path: 'admin',
      component: AdminLayoutComponent,
      canActivate: [AuthGuard, RoleGuard],
      data: { expectedRole: 'ROLE_ADMIN' },
      resolve: { profileLoaded: ProfileResolver },
      children: [
        { path: 'dashboard', component: AdminDashboardComponent, data: { title: 'Admin Dashboard' } },
        { path: 'clients', component: AdminMembersList, data: { title: 'Clients' } },
        { path: 'clients/create', component: AdminMemberForm, data: { title: 'Ajouter Client' } },
        { path: 'clients/details/:id', component: AdminMemberDetails, data: { title: 'Client Details' } },
        { path: 'clients/edit/:id', component: AdminMemberForm, data: { title: 'Modifier Client' } },
        
        { path: 'agents', component: AdminAgentsList, data: { title: 'Agents' } },
        { path: 'agents/create', component: AdminAgentForm, data: { title: 'Ajouter Agent' } },
        { path: 'agents/details/:id', component: AdminAgentDetails, data: { title: 'Agent Details' } },
        { path: 'agents/edit/:id', component: AdminAgentForm, data: { title: 'Modifier Agent' } },
        
        { path: 'reservations', component: AdminReservationsListComponent, data: { title: 'Réservations' } },
        { path: 'reservations/details/:id', component: AdminReservationDetailsComponent, data: { title: 'Réservation Details' } },

        { path: 'reservations/:reservationId/offers/create', component: AdminOfferFormComponent, data: { title: 'Réservations Offer' }},
        { path: 'reservations/:reservationId/feedback/details', component: FeedbackDetailsComponent, data: { title: 'Mes Évaluations'}},
        { path: 'reservations/:reservationId/offers/:offerId/edit', component: AdminOfferFormComponent, data: { title: 'Réservations Offer' }},


        { path: 'articles', component: AdminBlogsComponent, data: { title: 'Articles' } },
        { path: 'articles/create', component: AdminBlogFormComponent, data: { title: 'Ajouter Articles' } },
        { path: 'articles/edit/:id', component: AdminBlogFormComponent, data: { title: 'Modifier Articles' } },

        { path: 'top-agents', component: AdminPeriodManagement, data: { title: 'Top agents' } },


        { path: 'contacts', component: AdminContactsList, data: { title: 'Demandes de contact' } },
        { path: 'contacts/details/:id', component: AdminContactDetails, data: { title: 'Demande de contact Details' } },
      ]
    },

     {
        path: 'member',
        component: MemberLayoutComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { expectedRole: 'ROLE_USER' },
        resolve: { profileLoaded: ProfileResolver },
        children: [
          { path: 'profile', component: MemberProfile, data: { title: 'Mon Profil' } },
          { path: 'reservations', component: MemberReservations, data: { title: 'Réservations' } },
          { path: 'reservations/create', component: MemberReservationCreate, data: { title: 'Reserver' }},
          { path: 'reservations/details/:id', component: MemberReservationDetails, data: { title: 'Réservation Details' } },
          { path: 'reservations/edit/:id', component: MemberReservationUpdate, data: { title: 'Modifier réservation' } },
         
          { path: 'reservations/:reservationId/feedback', component: FeedbackFormComponent, data: { title: 'Évaluer le Service'}},
          { path: 'reservations/:reservationId/feedback/details', component: FeedbackDetailsComponent, data: { title: 'Mes Évaluations'}},
                  
          { path: '', redirectTo: 'profil', pathMatch: 'full' }
        ]
      },

    { path: '**', redirectTo: '' } // Handle invalid routes
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
